module.exports = __webpack_public_path__ + "assets/f031ccf6e7eeef395e431e11ee2dc054.svg";